module.exports = __webpack_public_path__ + "img/2.ec6aa3b7.png";